export const Pencil16Icon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12.0013 6.66671L9.33465 4.00004M1.66797 14.3334L3.92421 14.0827C4.19987 14.0521 4.3377 14.0367 4.46653 13.995C4.58083 13.958 4.6896 13.9058 4.78989 13.8396C4.90294 13.7651 5.001 13.667 5.19712 13.4709L14.0013 4.66671C14.7377 3.93033 14.7377 2.73642 14.0013 2.00004C13.2649 1.26366 12.071 1.26366 11.3347 2.00004L2.53045 10.8042C2.33433 11.0003 2.23627 11.0984 2.16173 11.2114C2.09559 11.3117 2.04331 11.4205 2.00631 11.5348C1.96461 11.6636 1.94929 11.8015 1.91866 12.0771L1.66797 14.3334Z" />
    </svg>
  );
};
